import type { File as FileModel } from './common';

export enum SignatureType {
  ADVANCED_CH = 1,
  QUALIFIED_CH_ZERTES = 2,
  BASIC = 4,
  ADVANCED_EU_EIDAS = 8,
  QUALIFIED_EU_EIDAS = 16,
  ADVANCED_CH_FAST_TRACK = 128,
}

export interface SignaturePlaceholder {
  id: string;
  approverId: number | string;
  pageNumber: number;
  x: number;
  y: number;
  width?: number;
  with?: number;
  height: number;
  author?: string;
}

export interface SignatureEvidence {
  type: SignatureType;
  enabled: boolean;
}

export interface SigningFiles {
  toSign?: FileModel[];
  signed?: FileModel[];
  declined?: FileModel[];
  seal?: FileModel[];
  pending?: FileModel[];
  completed?: FileModel[];
  uploads?: FileModel[];
  allowed?: FileModel[];
  expiring?: FileModel[];
}
